import Vue from "vue";
import axios from "axios";
import $ from "jquery";
import search_utils from "@/libs/search_utils";
import _ from "lodash";
import { stringify } from "qs";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;


// === STATE =====================================================================================
const state = {
	filters: {
		name: "",
		location: "",
		departement: "",
		segment: "",
		type: "",
		status: "",
		year_creation: "",
		contributeur: "",
		evalis: "",
		bounding_box: false,
		size: process.env.VUE_APP_SEARCH_SIZE
	},
	facets: {
		years: "",
		evalisReference: "",
		email: "",
		departement: {},
	},
	results: [],
	active_project: false,
	new_study_for_active_project: false,
};


// === GETTERS =====================================================================================
const getters = {
	search: state => { return state; },
	active_project: state => { return state.active_project; },
	new_study_for_active_project: state => { return state.new_study_for_active_project; },
};


// === ACTIONS =====================================================================================
const actions = {
	async search_projects ({commit,state}) {
		const filters = state.filters;
		const filters_body = _.clone(filters);
		for(const filter in filters_body){
			if(filters_body[filter].length === 0 || (filter == "bounding_box" && !filters_body[filter])){
				delete filters_body[filter];
			}
		}
		const projects = (await axios.post( `${API_BASE_URL}api/projet/search`, filters_body)).data.content;
		commit("EDIT_SEARCH_STATE", {
			results: projects,
		});
	},
	
	async init_facets ( { commit, state, dispatch }) {
		// try{
		// 	let project_query_body = search_utils.get_project_query(state.filters, 0);
		// 	project_query_body = project_query_body.build();
		// 	let study_query_body = search_utils.get_study_query(state.filters, 0);
		// 	study_query_body = study_query_body.build();
			
		// 	const project_response = await axios.post(`${API_BASE_URL}Cdc/Projet/Search`, project_query_body);
		// 	dispatch("set_facets", { aggs: project_response.data.content.aggregations });
			
		// 	const study_response = await axios.post( `${API_BASE_URL}Cdc/Etude/Search`, study_query_body);
		// 	dispatch("set_facets", { aggs: study_response.data.content.aggregations });
		// } catch (error) {
		// 	console.error("Failed to init facets with filters ==", state.filters, error);
		// }
	},
	async search_projects_by_studies ( { commit, state, dispatch }) {
		let prefix_project_id=[]
		try{
			let projects = [];
			let study_query_body = search_utils.get_study_query(state.filters, 10000);
			study_query_body = study_query_body.build();
			const study_response = await axios.post( `${API_BASE_URL}Cdc/Etude/Search`, study_query_body);
			projects = _.map(study_response.data.content.hits.hits, "_source");
			const projects_by_projects = _.groupBy(projects, "projet.id");
			prefix_project_id = _.keys(projects_by_projects)
		}catch(error){
			console.error("search_projects_by_studies - error while pre-searching studies", error);
		}
		let project_query_body = search_utils.get_project_query(state.filters, process.env.VUE_APP_ELASTIC_TOP);
		
		let has_study_filter = search_utils.check_study_filter(state.filters);
		if(has_study_filter){ 
			project_query_body = project_query_body.filter("terms", "id.keyword",prefix_project_id).build();
		}else{
			project_query_body = project_query_body.build();
		}
		
		
		let projects = [];
		try {
			//Search projects
			const project_response = await axios.post(`${API_BASE_URL}Cdc/Projet/Search`, project_query_body);
			//dispatch("set_facets", { aggs: project_response.data.content.aggregations });
			projects = _.map(project_response.data.content.hits.hits, "_source");
			const projects_by_projects = _.groupBy(projects, "id");
			let study_query_body = search_utils.get_study_query(state.filters, process.env.VUE_APP_ELASTIC_TOP);
			study_query_body = study_query_body.filter("terms", "projet.id.keyword",_.keys(projects_by_projects)).build();

			try {
				// Search studies
				const study_response = await axios.post( `${API_BASE_URL}Cdc/Etude/Search`, study_query_body);
				//dispatch("set_facets", { aggs: study_response.data.content.aggregations });
				const studies = _.map(study_response.data.content.hits.hits, "_source");
				const studies_by_projects = _.groupBy(studies, "projet.id");

				//filter projects to keep only project having studies
				let filter = Object.entries(studies_by_projects).map(( [k, v] ) => (k.toString()));
				projects = projects.filter(p => filter.includes(p.id));
			
				for (const project of projects) {
					const study_list = studies_by_projects[project.id];

					if (_.isEmpty(study_list)) {
						console.error(`ERROR - project ${project.id} has no matching studies`);
					}else{
						project.etudes = study_list;
						const sorted_studies = _.sortBy(study_list, "dateCreation");
						project.statut = _.uniqWith(_.map(sorted_studies, "statut"), _.isEqual);
						project.statut = _.orderBy(project.statut, item => item.slug, ["asc"]);
						project.segment = _.first(sorted_studies).segment;
					}
				}
			} catch (error) {
				console.error("search_projects_by_studies - error while searching projects", error);
			}
			commit("EDIT_SEARCH_STATE", {
				results: projects,
			});
		} catch (error) {
			console.error("Failed to load studies with filters ==", state.filters, error);
		}
	},

	async load_active_project ({ commit }, data) {
		if (!data || !data.project_id) {
			throw Error("VueX action load_active_project - invalid data");
		}
		try {
			const r = await axios.get(`${API_BASE_URL}api/projet/${data.project_id}`);
			commit("EDIT_SEARCH_STATE", {
				active_project: r.data.content
			});
		} catch (error) {
			console.error("VueX action load_active_project - error while retrieving project", error);
		}
	},

	set_facets ({ commit, state }, data) {
		if (!data || !data.aggs) {
			throw Error("VueX action set_facets - invalid data");
		}
		let facets = {};
		for (const [facet, values] of _.entries(data.aggs)) {
			let facet_dict = "";
			//YEARS
			if (facet == 'years'){
				facet_dict = _.keyBy(values.buckets, b => {
					return b.key_as_string.substring(0,4);
				});
			}
			//DEPARTEMENT
			else if(facet == 'departement'){
				facet_dict = _.map(values.buckets, function (b) {
					return {
						code : b.key,
						label : b.key.concat(' - ',b.label.buckets[0].key)
					}
				});
			}else{
				facet_dict = _.keyBy(values.buckets, b => {
					return b.key;
				});
			}
			facets[facet] = facet_dict;
		}
		commit("SET_FACETS", { facets: facets });
	},

	set_filter: function ({ commit, dispatch }, data) {
		if (data["bounding_box"]) {
			data.location = "";
			data.departement = "";
		}
		else data.bounding_box = false;

		commit("SET_FILTER", data);
		//dispatch("search_projects");
	},


	toggle_active_project: function ({ commit, state }, data) {
		$("#map .map-icon.expanded").removeClass("expanded");

		if (state.active_project == data.project)
			commit("EDIT_SEARCH_STATE", {
				active_project: false
			});
		else {
			commit("EDIT_SEARCH_STATE", {
				active_project: data.project
			});
			$("#map #pin-project-" + data.project.id).addClass("expanded");
		}
	},


	set_new_study_for_active_project ( { commit }, data ) {
		commit("SET_NEW_STUDY_FOR_ACTIVE_PROJECT", data);
	},

};


// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_SEARCH_STATE: function (state, data) {
		for (const i in data) {
			Vue.set(state, i, data[i]);
		}
	},

	SET_FILTER: function (state, data) {
		for (const i in data) {
			//keep always size as init
			if(i!='size')
				Vue.set(state.filters, i, data[i]);
		}
	},

	SET_NEW_STUDY_FOR_ACTIVE_PROJECT ( state, data ) {
		Vue.set(state, "new_study_for_active_project", data.value );
	},

	SET_FACETS (state, data) {
		for (const name in data.facets) {
			Vue.set(state.facets, name, data.facets[name]);
		}
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};